// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3_1yN","fileBtn":"File_fileBtn__IaroL","closeBtn":"File_closeBtn__zn_mt","fileSelected":"File_fileSelected__1bD38","disabled":"File_disabled__3Zk2d"};